import React from "react";
import { useTranslation } from "react-i18next";
import FormatDate from "go-core/components/Formatters/FormatDate";
import { OrganizationFeatureApi } from "../../../../../../../services/Api/types";

interface Props {
	feature: OrganizationFeatureApi;
}

const OrganizationFeatureItem = ({ feature }: Props) => {
	const { t } = useTranslation("admin");

	const getCardBackgroundColor = () => {
		if (feature.used) return "#DFF9E4";
		if (feature.enabled) return "#FCFEE5";
		return "#FEE6E5";
	};

	const getCardFontColor = () => {
		if (feature.used) return "#28A745";
		if (feature.enabled) return "#ffc107";
		return "#DC3545";
	};

	const getPoints = () => {
		return `${feature.points ?? 0}/${feature.potential_points ?? 0}`;
	};

	const renderStatus = () => {
		if (feature.used) return "Używany";
		if (feature.enabled) return "Włączony";
		return "Potencjał";
	};
	return (
		<div className="d-flex align-items-center justify-content-between organization-product-category-product">
			<div className="d-flex align-items-center gap-2">
				<div style={{ backgroundColor: getCardBackgroundColor() }} className="product-points">
					<p className="mb-1" style={{ color: getCardFontColor() }}>{`${getPoints()} ${t(
						"modules.organization.field.points_shortcut.title"
					).toLowerCase()}`}</p>
					<small className="mb-0" style={{ color: getCardFontColor() }}>{`${renderStatus()}`}</small>
				</div>
				<div className="d-flex flex-column gap-1">
					<h5 className="mb-0">
						{feature.name} <small>{feature.product_name}</small>
					</h5>
					<small className="text-muted">
						Sprzedał:
						<strong className="ms-1">
							{feature.sold_by_partner?.name ?? t("modules.organization.field.lack.title")}
						</strong>
					</small>
					<small className="text-muted">
						Wdrożył:
						<strong className="ms-1">
							{feature.activated_by_partner?.name ?? t("modules.organization.field.lack.title")}
						</strong>
					</small>
					{feature.notes && (
						<small className="text-muted">
							Notatka:
							<strong className="ms-1">{feature.notes}</strong>
						</small>
					)}
					<small className="text-muted">
						Subskrypcja:
						<strong className="ms-1">{feature.subscription ? "Tak" : "Nie"}</strong>
					</small>
				</div>
			</div>
			<div className="d-flex flex-column align-items-end">
				<h5 className="mb-0">{`30 dni użycie: ${feature.last_usage ? feature.last_usage : "Brak"}`}</h5>
				<small>{`Pierwsz użycie: ${feature.first_used_at ? FormatDate(feature.first_used_at) : "Brak"}`}</small>
				<small>{`Ostatnie użycie: ${feature.last_used_at ? FormatDate(feature.last_used_at) : "Brak"}`}</small>
			</div>
		</div>
	);
};

export default OrganizationFeatureItem;
